import React from "react";
import appConfig from "configs/app.config";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "utils/hooks/useAuth";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import useQuery from "utils/hooks/useQuery";
import { getItem } from "utils/safeStorage";

const { unAuthenticatedEntryPath, unAuthenticatedEntryPathProje } = appConfig;

const ProtectedRoute = () => {
  const { authenticated } = useAuth();
  const isWelcome = getItem("welcome");
  const location = useLocation();
  const query = useQuery();
  const boxCodeUser = query.get("branchcode");
  const domain = window.location.host.slice(
    0,
    window.location.host.indexOf(".")
  );
  const isProje = domain.includes("proje");

  if (!authenticated) {
    return (
      <Navigate
        to={`${
          boxCodeUser
            ? "/sign-up"
            : isWelcome
            ? isProje
              ? unAuthenticatedEntryPathProje
              : "/sign-in"
            : isProje
            ? unAuthenticatedEntryPathProje
            : unAuthenticatedEntryPath
        }?${REDIRECT_URL_KEY}=${location.pathname + location.search}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
